import axios from 'axios'
import qs from 'qs'
import {
  message
} from '../common/js/messages'
import {
  cookies
} from '../api/util'
import router from '../../router'
//import * as _ from '../common/js/config'
//import router from '../../router'
// import { Loading } from 'element-ui'

const fetch = axios.create({
  timeout: 30000,
  baseURL: window.BASE_URL,
  // baseURL: 'https://loadtest.eimageglobal.com/basis-web/',
  // 请求头
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded'
    // withCredentials: true
  }
})
const instance = axios.create({ //免登
  timeout: 5000,
  baseURL: window.BASE_URL,
  // baseURL: 'https://loadtest.eimageglobal.com/basis-web/',
  // 请求头
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    // withCredentials: true
  }
})

function GetToken(name) {
  let search = window.location.href;
  let pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
  let matcher = pattern.exec(search);
  let items = null;
  if (null != matcher) {
    try {
      items = decodeURIComponent(decodeURIComponent(matcher[1]));
    } catch (e) {
      try {
        items = decodeURIComponent(matcher[1]);
      } catch (e) {
        items = matcher[1];
      }
    }
  }
  return items;
}
//axios.interceptors.request.use = fetch.interceptors.request.use;

// 添加请求拦截器  POST传参序列化
fetch.interceptors.request.use((config) => {

  // let Token = GetToken('token');
  // if (Token != null && Token != undefined) {
  //   let TOKEN = qs.stringify({
  //     'Teyangtoken': Token,
  //   })
  //   instance.post('/noPasswordlogin.json', TOKEN).then(res => { //查询影像所见和诊断结果
  //     if (res.data.code == "SUCCESS") {
  //       cookies.delAllCookie()
  //       cookies.setCookie('eimageglobaltid', res.data.model.eimageglobaltid)
  //       // user()
  //       // let userInfo = {
  //       //   userName: res.data.model.user.userName,
  //       //   userPhoto: res.data.model.user.userPhoto
  //       // }
  //       // return userInfo
  //     } else if (res.data.code === 'NOLOGIN') {
  //       message('token已失效，请重新登录！')
  //       cookies.delAllCookie()
  //       setTimeout(function() {
  //         router.push('/')
  //       }, 1000)
  //     }
  //   }).catch(() => {});

  // } else if (config.method === 'post') {
  if (config.method === 'post') {
    config.data = qs.stringify(config.data, {
      allowDots: true
    })
  }
  return config
}, (error) => {
  // loadinginstace.close()
  message('加载超时', false)
  return Promise.reject(error)
})
// 添加响应拦截器
fetch.interceptors.response.use((res) => {
      // var customerId=window.getCookie('eimageglobaltid');
      //  if(customerId == undefined) {
      //     window.open(`${window.loginURL}`,'_blank')
      //   }else{
      //       router.push('/login')
      //   }


  if (res.data.resultCode === 'NOLOGIN') {
    message('请先登录！')
    cookies.delAllCookie()
    setTimeout(function() {
     if(!loginURL) {

       router.push('/login')

     } else{

       window.location.href = `${window.loginURL}`
     }
    // router.push('/login')
  }, 1000)
    // } else if (res.data.resultCode === 'FAILED') {
    //   cookies.delCookie()
    //   message('token已过期，请重新登录！')
    //   setTimeout(function() {
    //     router.push('/')
    //   }, 1500)
  } else {
    return res
  }
}, (err) => {
  // loadinginstace.close()
  // 对响应错误做点什么
  if (!err.response) {
    message('请求超时，请稍后重试')
  } else if (err.response.status >= 500) {
    message('服务器开了个小差，请稍后重试')
  } else if (err.response.status === 404) {
    message('请求地址不存在')
  } else if (err.response.status >= 400) {
    message('请求错误，请检查参数或请求头')
  }
  return Promise.reject(err)
})

// 登录失效拦截器

const http = {
  get(url, parmars) {
    try {
      return fetch.get(url, parmars)
    } catch (err) {
      console.error(err)
    }
  },
  post(url, data, config) {
    try {
      return fetch.post(url, data, config)
    } catch (err) {
      console.error(err)
    }
  }
}

export default http



// WEBPACK FOOTER //
// ./src/api/http.js